import React, { useState } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from "reactstrap";
import { useSelector } from "react-redux";
import { postHomologarCuentas } from "../../helpers/backend";
import Swal from 'sweetalert2';

const CatastroEnel = ({ cliente, casoId }) => {
  const theme = useSelector((state) => state.theme.theme) || "light";

  const catastrosEnel = cliente?.catastros_enel || [];
  const [modal, setModal] = useState(false);
  const [nuevaCuentaEnel, setNuevaCuentaEnel] = useState("");
  const [selectedCatastro, setSelectedCatastro] = useState(null);

  const handleHomologacion = async (catastro) => {
    setSelectedCatastro(catastro);
    setModal(true);
  };

  const handleSubmitHomologacion = async () => {
    if (!nuevaCuentaEnel.trim() || !/^\d+$/.test(nuevaCuentaEnel)) {
      Swal.fire({
        title: 'Error',
        text: 'Por favor ingrese un número de cuenta válido',
        icon: 'error'
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append('nueva_cuenta_enel', nuevaCuentaEnel);

      const response = await postHomologarCuentas(casoId, formData);
      console.log(response);

      if (response.data && response.data.success) {
        const resultado = response.data.resultado;
        await Swal.fire({
          title: 'Éxito',
          text: response.data.message,
          icon: 'success',
          html: `
            <div class="text-start">
              <p><strong>Detalles de la homologación:</strong></p>
              <p><strong>Origen:</strong></p>
              <ul>
                <li>Nombre: ${resultado.origen_nombre}</li>
                <li>Cuenta anterior: ${resultado.origen_cuenta_enel_anterior}</li>
              </ul>
              <p><strong>Destino:</strong></p>
              <ul>
                <li>Nombre: ${resultado.destino_nombre}</li>
                <li>Cuenta anterior: ${resultado.destino_cuenta_enel_anterior}</li>
                <li>Nueva cuenta: ${resultado.nueva_cuenta_enel}</li>
              </ul>
            </div>
          `
        });
        setModal(false);
      } else {
        throw new Error(response.data?.message || 'No se recibió confirmación del servidor');
      }
    } catch (error) {
      console.error("Error al homologar cuenta:", error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo procesar la homologación. Por favor intente nuevamente.',
        icon: 'error'
      });
    }
  };

  // Componente para mostrar un campo individual
  const InfoField = ({ label, value }) => (
    <div className="vb-field-group">
      <div className="vb-field-label">{label}</div>
      <div className="vb-field-value">{value || <span className="text-muted font-italic">Sin datos</span>}</div>
    </div>
  );

  // Función para renderizar una sección de datos
  const renderSection = (title, icon, children) => (
    <div className="vb-section-card h-100">
      <div className="vb-card-header">
        <i className={icon}></i>
        <span>{title}</span>
      </div>
      <div className="vb-card-body">
        {children}
      </div>
    </div>
  );

  if (!catastrosEnel || catastrosEnel.length === 0) {
    return (
      <div className="vb-empty-data">
        <i className="mdi mdi-flash-outline"></i>
        <h5>No hay datos de Catastro Enel</h5>
        <p>No se encontraron registros de Enel asociados.</p>
      </div>
    );
  }

  return (
    <div className="vb-scroll-container" data-theme={theme}>
      {catastrosEnel.map((catastro, index) => (
        <div key={index} className="mb-5">

          {/* Header / Main Info */}
          <div className="vb-section-card mb-4" style={{ borderLeft: '5px solid #fbbf24' }}>
            <div className="p-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h4 className="mb-2 text-warning" style={{ fontWeight: 800 }}>
                  <i className="mdi mdi-flash me-2"></i>
                  Catastro Enel {catastrosEnel.length > 1 ? `#${index + 1}` : ""}
                </h4>
                <div className="badge bg-light text-secondary border p-2 mb-3">
                  Cuenta: <strong>{catastro.nro_cuenta || "Sin datos"}</strong>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <i className="mdi mdi-map-marker text-warning"></i>
                  <span className="fw-bold text-dark">{catastro.direccion || "Sin dirección registrada"}</span>
                </div>
              </div>

              <div>
                <button
                  className="btn-vb btn-vb-warning"
                  onClick={() => handleHomologacion(catastro)}
                >
                  <i className="mdi mdi-swap-horizontal me-1"></i> Homologar Cuenta
                </button>
              </div>
            </div>
          </div>

          <Modal isOpen={modal} toggle={() => setModal(false)} centered>
            <ModalHeader toggle={() => setModal(false)} className="bg-light">
              <i className="mdi mdi-swap-horizontal me-2 text-warning"></i> Homologar Cuenta ENEL
            </ModalHeader>
            <ModalBody className="p-4">
              <Form>
                <FormGroup>
                  <Label for="nuevaCuentaEnel" className="fw-bold text-muted text-uppercase small">Nueva Cuenta ENEL</Label>
                  <Input
                    type="text"
                    id="nuevaCuentaEnel"
                    value={nuevaCuentaEnel}
                    onChange={(e) => setNuevaCuentaEnel(e.target.value)}
                    placeholder="Ingrese el nuevo número de cuenta"
                    pattern="\d*"
                    className="form-control-lg border-warning"
                  />
                  <small className="text-muted mt-2 d-block">
                    <i className="mdi mdi-information me-1"></i> El número de cuenta debe contener solo dígitos.
                  </small>
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter className="bg-light border-0">
              <Button color="link" className="text-muted text-decoration-none" onClick={() => setModal(false)}>
                Cancelar
              </Button>
              <button className="btn-vb btn-vb-primary px-4" onClick={handleSubmitHomologacion}>
                Confirmar
              </button>
            </ModalFooter>
          </Modal>

          <Row className="g-4">
            {/* Información del Usuario y Clasificación */}
            <Col lg={6}>
              {renderSection(
                "Información del Usuario",
                "mdi mdi-account-card-details-outline",
                <Row>
                  <Col sm={6}>
                    <InfoField label="Nombre" value={catastro.nombre_usuario} />
                    <InfoField label="Número de Medidor" value={catastro.nro_medidor} />
                  </Col>
                  <Col sm={6}>
                    <InfoField label="Número de Cuenta" value={catastro.nro_cuenta} />
                  </Col>
                </Row>
              )}
            </Col>

            <Col lg={6}>
              {renderSection(
                "Clasificación",
                "mdi mdi-tag-text-outline",
                <Row>
                  <Col sm={4}>
                    <InfoField label="Clase" value={catastro.clase} />
                  </Col>
                  <Col sm={4}>
                    <InfoField label="Subclase" value={catastro.subclase} />
                  </Col>
                  <Col sm={4}>
                    <InfoField label="Grupo" value={catastro.grupo} />
                  </Col>
                </Row>
              )}
            </Col>

            {/* Ubicación y Cuentas */}
            <Col lg={6}>
              {renderSection(
                "Ubicación y Ciclo",
                "mdi mdi-map-marker-path",
                <Row>
                  <Col sm={6}>
                    <InfoField label="Ciclo" value={catastro.ciclo} />
                    <InfoField label="Zona" value={catastro.zona} />
                  </Col>
                  <Col sm={6}>
                    <InfoField label="Sucursal" value={catastro.sucursal} />
                    <InfoField label="Marca" value={catastro.marca} />
                  </Col>
                </Row>
              )}
            </Col>

            <Col lg={6}>
              {renderSection(
                "Cuentas y Operador",
                "mdi mdi-file-tree",
                <Row>
                  <Col sm={6}>
                    <InfoField label="Cuenta Padre" value={catastro.cta_padre} />
                    <InfoField label="Cuenta Hijo" value={catastro.cta_hijo} />
                  </Col>
                  <Col sm={6}>
                    <InfoField label="Operador" value={catastro.operador} />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default CatastroEnel;